import styled from 'styled-components';

import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

import { FileTag } from '../file-tag';

type UserMessageProps = {
  id: string;
  text: string;
  files?: string[];
};

export const UserMessage = ({ id, text, files }: UserMessageProps) => {
  return (
    <Stack space={2}>
      <UserMessageContainer>
        <Text color="elementBlue100" font="regular14" text={text} />
      </UserMessageContainer>
      {Array.isArray(files) &&
        files.map((name: string) => {
          return <FileTag key={`${id}-${name}`} name={name} />;
        })}
    </Stack>
  );
};

const UserMessageContainer = styled.div({
  width: '100%',
  borderRadius: pxToRem(7),
  padding: pxToRem(12),
  background: theme.color.blueTrans10,
});
